export const isUserLoginType = "IS_LOGIN_SUCCESS"

export const userLoginInfoType = "USER_LOGIN_INFO"

export const updateUserProfileType = "UPDATE_USER_PROFILE"

export const allSocialLinksType = "ALL_SOCIAL_LINKS"

export const updateLinks = 'UPDATE_SOCIAL_LINKS'

export const logoutUser = "LOGOUT_USER_TYPE"

export const updateLanguageType = "UPDATE_LANGUAGE_TYPE"
